<template>
    <div class="other-option-sec donation-details">
        <div class="donation-option-details">
          <img src="/static/images/donation-box.png" class="donation-box"/>
          <div>
            <!-- <img :src="childOption.image" class="donation-type-img"/> -->
            <img src="/static/images/mosque-fund.png" class="donation-type-img" style="margin-top:15px;"/>
          </div>
          <div class="title">
            {{childOption.title | translate}}
          </div>
        </div>

        <!-- <div class="donation-option-details">
        <img src="/static/images/donation-box.png" class="donation-box"/>
        <div>
            <img :src="childOption.image" class="donation-type-img" :id="'image-'+option.id"/>
        </div>
        <div class="title">{{childOption.title | translate}}</div>
      </div> -->
    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['childOption'],
  computed: {
  },
  methods: {
  },
  components: {
  },
  mounted: function () {
  }
}
</script>
<style scoped>
      .donation-details {
      /* background-image: url('/static/images/donation-box.png'); */
      background-repeat: no-repeat;
      /* height: 160px; */
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      z-index: 2;
      height: 100%;
      margin: 0 auto;
    }

    .donation-details img.donation-type-img {
        width: 35px;
        margin-right: 10px;
        z-index: 4;
        margin-left: 30px;
    }
    div.donation-details .title {
      color: #eca861;
      font-size: 20px;
      text-shadow: 0px 0px 5px #512806;
      justify-content: center;
      border-radius: 2px;
      transition: all 0.3s ease-out 0s;
      text-shadow: -1px -1px 0 #512806, 1px -1px 0 #512806, -1px 1px 0 #512806, 1px 1px 0 #512806;
      z-index: 4;
      line-height: 18px;
      padding-right: 27px;
    }
    .donation-option-details {
      /* padding: 40px 30px 30px; */
      /* background-color: #512806; */
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .donation-option-details > div {
      z-index: 4;
    }
    div[dir='rtl'] .donation-details img {
      margin-right: 0;
      margin-left: 45px;
    }
  .donation-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width:75%;
    height: 75%;
  }
  div[dir='rtl'] .donation-details img {
    margin-left: 20px;
  }
  div[dir='rtl'] div.donation-details .title {
    padding-right: 0;
    padding-left: 45px;
    line-height: 25px;
  }
  @media only screen and (min-width: 2000px) {
    .donation-details {
      width: 90%;
      height: 100%;
    }
    .donation-box {
      width:90%;
    }
    .donation-option-details {
      padding: 12% 6% 12% 5%;
    }
    .donation-details img.donation-type-img {
      width: 160px;
      margin-right: 20px;
    }
    div.donation-details .title {
      font-size: 90px;
      font-weight: 900;
      line-height: 95px !important;
    }
    div[dir='rtl'] .donation-details img {
      margin-left: 40px;
    }
  }

 @media screen and (min-width: 1200px) and (min-height: 904px) {
   .donation-details {
     width: 90%;
   }
   .donation-box {
     width: 90%;
     max-height: 145px;
   }
   .donation-details img.donation-type-img {
     width: 40px;
     margin-left: 25px;
     margin-right: 7px;
   }
   div.donation-details .title {
     font-size: 24px;
     line-height: 26px;
   }
   div[dir='rtl'] .donation-details {
     width: 80%;
   }
   div[dir='rtl'] .donation-details .title {
    font-size: 27px;
    line-height: 30px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/child-donation-options.vue